import { SwitchButton } from "components/switchButton";
import { IPasscodeItem } from "interfaces";
import { get } from "lodash";
import moment from "moment";
import { HistoryLogButton } from "components/historyLogButton";
import { isHaveActionPermission } from "utills/helpers";
import { PRIVATE_FLOW_TYPES } from "utills/constants";

interface PasscodeCardProps {
  data?: IPasscodeItem[];
  pageSize: number;
  currentPage: number;
  _toggleActive: (id: string, isActive: boolean) => void;
}

const getPrivateFlowTypeLabel = (value?: string) =>
  PRIVATE_FLOW_TYPES.find((type) => type.value === value)?.label || "";

export const PasscodeCard = ({
  data = [],
  pageSize = 10,
  currentPage = 1,
  _toggleActive,
}: PasscodeCardProps) => {
  return (
    <ul className="bg-white">
      {data.map((item: IPasscodeItem, index: number) => (
        <div
          key={index}
          className="flex flex-col gap-y-4 overflow-hidden shadow-md ring-1 ring-gray-900/5 [&:not(:last-child)]:mb-4 p-4 rounded-xl"
        >
          <div className="w-full flex items-center justify-between">
            <SwitchButton
              checked={item.is_active}
              disabled={!isHaveActionPermission("private_code_email", "events", "edit")}
              onChange={() => _toggleActive(item.id, item.is_active)}
            />

            <div className="flex items-center gap-x-[8px]">
              <HistoryLogButton 
                className="!w-8 !h-8 border-none text-black p-0 bg-gray-200 hover:bg-gray-200 active:bg-gray-300"
                resource={`private-flow/event-passcodes/${item.id}/history`}
                hideTitle
              />
            </div>
          </div>

          <li className="relative flex items-start justify-between gap-x-6">
            <p className="flex-1 text-sm font-semibold leading-6">No</p>
            <p className="flex-1 text-right text-sm leading-6">
              {(currentPage - 1) * pageSize + 1 + index}
            </p>
          </li>
          <li className="relative flex items-start justify-between gap-x-6">
            <p className="flex-1 text-sm font-semibold leading-6">Passcode/Email Address</p>
            <p className="flex-1 text-right text-sm leading-6 font-medium">
              {get(item, "auth_identifier", "")}
            </p>
          </li>
          <li className="relative flex items-start justify-between gap-x-6">
            <p className="flex-1 text-sm font-semibold leading-6">Event name</p>
            <p className="flex-1 text-right text-sm leading-6">
              {get(item, "event_name_en", "")}
            </p>
          </li>
          <li className="relative flex items-start justify-between gap-x-6">
            <p className="flex-1 text-sm font-semibold leading-6">Private Flow Type</p>
            <p className="flex-1 text-right text-sm leading-6">
              {getPrivateFlowTypeLabel(get(item, "private_flow_type", ""))}
            </p>
          </li>
          <li className="relative flex items-start justify-between gap-x-6">
            <p className="flex-1 text-sm font-semibold leading-6">Used Count</p>
            <p className="flex-1 text-right text-sm leading-6">
              {item.usage_count}/{item.max_usage_count}
            </p>
          </li>
          <li className="relative flex items-start justify-between gap-x-6">
            <p className="flex-1 text-sm font-semibold leading-6">Created at/by</p>
            <div className="flex-1 text-right text-sm leading-6">
              <p>{item.created_at ? moment(item.created_at).format("DD/MM/YYYY HH:mm:ss") : ""}</p>
              <p>{item.created_by}</p>
            </div>
          </li>
        </div>
      ))}
    </ul>
  );
};
